'use client';
import MarqueeCarousel from '@c/MarqueeCarousel';
import SafeImage from '@ui/SafeImage';
import { Star } from 'lucide-react';

export type FeaturedSeller = {
  name: string;
  location: string;
  avatar: string;
  rating: string;
  reviews: string;
  listings: string;
};

const SellerCard = ({ seller }: { seller: FeaturedSeller }) => (
  <div className="flex h-[40.25rem] w-[29.5rem] shrink-0 snap-center flex-col items-center justify-center gap-[2rem] rounded-[3rem] bg-[#222222] px-[2rem] pb-[2rem] pt-[5rem]">
    <div className="size-[12.75rem] shrink-0 overflow-hidden rounded-full">
      <SafeImage
        src={seller.avatar}
        alt={seller.name}
        className="h-full w-full object-cover"
      />
    </div>
    <div className="flex flex-1 flex-col items-center justify-center gap-[0.5rem] text-center text-white">
      <span className="text-[2.25rem] font-bold leading-[1.3] tracking-[-0.01em]">
        {seller.name}
      </span>
      <span className="text-[1.5rem] font-medium leading-[1.4] opacity-60">
        {seller.location}
      </span>
    </div>
    <div className="flex w-full gap-[1.5rem] rounded-[2rem] bg-black p-[1.5rem]">
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="flex items-center justify-center gap-[0.25rem]">
          <Star className="h-[2rem] w-[2rem] fill-brand-secondary text-brand-secondary" />
          <span className="text-[2rem] font-bold leading-[1.5] text-white">
            {seller.rating}
          </span>
        </div>
        <span className="text-[1.5rem] font-medium leading-[1.4] text-white opacity-60">
          {seller.reviews} reviews
        </span>
      </div>
      <div className="w-px shrink-0 bg-white/20" />
      <div className="flex flex-1 flex-col items-center justify-center">
        <span className="text-[2rem] font-bold leading-[1.5] text-white">
          {seller.listings}
        </span>
        <span className="text-[1.5rem] font-medium leading-[1.4] text-white opacity-60">
          Listings
        </span>
      </div>
    </div>
  </div>
);

const FeaturedSellersCarousel = ({
  sellers,
}: {
  sellers: FeaturedSeller[];
}) => (
  <MarqueeCarousel
    items={sellers}
    renderItem={(seller) => <SellerCard seller={seller} />}
    contentClassName="gap-[1.5rem] px-[2rem] md:px-[15rem]"
    fadeClassName="from-black"
    dotClassName="bg-white"
  />
);

export default FeaturedSellersCarousel;
